<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="subtitle"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  <div class="si-donut-container">
    <div class="si-donut">
      <div class="si-donut__chart">
        <canvas baseChart type="doughnut" [labels]="labels" [datasets]="datasets" [options]="chartOptions"></canvas>
        <div class="si-donut__centre" [title]="totalTitle">
          <span class="si-donut__centre-label">{{ 'SALES_INSIGHTS_TOTAL' | translate }}</span>
          <span class="si-donut__centre-value">
            {{ totalText }}
            @if (unit) {
              <span class="si-donut__centre-unit">{{ unit }}</span>
            }
          </span>
        </div>
      </div>
      <ul class="si-donut__legend">
        @for (slice of slices; track slice.key) {
          <li class="si-donut__legend-item" [title]="slice.code ? slice.label + ' (' + slice.code + ')' : slice.label">
            <span class="si-donut__swatch" [style.background]="slice.colour"></span>
            <span class="si-donut__legend-label">
              {{ slice.label }}
              @if (slice.code) {
                <span class="si-donut__legend-code">{{ slice.code }}</span>
              }
            </span>
            <span class="si-donut__legend-share">{{ slice.share }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
</lib-sales-insights-card>
